import { hash } from './hash';

/**
 * Stand-in artwork for post media.
 *
 * There is no backend and no media pipeline yet, and the same reasoning that
 * keeps avatars local applies harder here: a feed that reaches out to a stock
 * photo service would not render in the Capacitor WebView offline, and it
 * would fill a scaffold with pictures the product's own capture rules forbid.
 *
 * These are soft abstract washes rather than fake photographs, so nobody
 * reviewing a screen mistakes placeholder content for a design decision about
 * what people post. Derived from the seed, so a given attachment looks the
 * same on every device and in every screenshot.
 */
export function placeholderStyle(
  seed: string,
  variant: 'image' | 'gif' = 'image',
): React.CSSProperties {
  const h = hash(seed);
  const base = h % 360;
  const shift = 40 + ((h >> 8) % 90);
  /* GIFs skew graphic and a little brighter; photographs skew atmospheric. */
  const c = variant === 'gif' ? 0.14 : 0.09;
  const l = variant === 'gif' ? 0.72 : 0.66;

  return {
    backgroundImage: [
      `radial-gradient(115% 85% at 18% 22%, oklch(${l + 0.14} ${c} ${base}) 0%, transparent 62%)`,
      `radial-gradient(95% 100% at 84% 78%, oklch(${l - 0.08} ${c * 0.9} ${(base + shift) % 360}) 0%, transparent 58%)`,
      `linear-gradient(155deg, oklch(${l + 0.04} ${c * 0.7} ${(base + shift / 2) % 360}), oklch(${l - 0.14} ${c * 0.8} ${(base + shift) % 360}))`,
    ].join(','),
  };
}
